import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BotaoCadastro from '../../../Componentes/BotaoCadastro';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import ModalView, { ModalTópico } from '../../../Componentes/ModalView';
import PesquisaInput from '../../../Componentes/PesquisaInput';
import TabelaComponente from '../../../Componentes/TabelaComponente';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import { apiService } from '../../../Services/ApiService';
import { StoreContexto } from '../../../Contexto/Provider';
import useDebounce from '../../../Hooks/debouceSearch';
import { FixedInput } from '../../../Componentes/TextInput';
import ModalConfirmacao from '../../../Componentes/ModalConfirmacao';
import useWindowSize from '../../../Hooks/windowSize';

export default function AmbienteLista() {
  const windowSize = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const [environments, setEnvironments] = useState([]);
  const [totalEnvironments, setTotalEnvironments] = useState(0);
  const [environment, setEnvironment] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const debounceSearch = useDebounce(searchText, 500);
  const [page, setPage] = useState(0);
  const [menuOptions, setMenuOptions] = useState(['Visualizar']);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    visible: false,
    message: '',
    operation: '',
    id: '',
  });
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });

  const { get, del } = apiService();
  const { auth } = useContext(StoreContexto);

  useEffect(() => {
    setIsMobile(windowSize.width < 1200);
  }, [windowSize]);

  useEffect(() => {
    getEnvironments();
  }, [page]);

  useEffect(() => {
    if (auth.perfilSalvo === 'OWNER') {
      setMenuOptions(['Visualizar', 'Excluir']);
    }
  }, [auth]);

  useEffect(() => {
    getEnvironments(debounceSearch);
  }, [debounceSearch]);

  const getEnvironments = async (currentSearchText = '') => {
    const queryParams = { page, size: 10, search: currentSearchText };
    setIsLoading(true);
    try {
      const data = await get('environments', queryParams);
      if (data) {
        setEnvironments(data.result || []);
        setTotalEnvironments(data.total || 0);
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar ambientes' });
    } finally {
      setIsLoading(false);
    }
  };

  const getEnvironmentById = async (environmentId) => {
    setIsLoading(true);
    try {
      const environment = await get(`environments/${environmentId}`);
      setEnvironment(environment);
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar ambientes' });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteEnvironment = async (environmentId) => {
    try {
      const response = await del(`environments/${environmentId}`);
      if (response) {
        await getEnvironments(debounceSearch);
      }
    } catch (error) {
      setModalError({
        visible: true,
        message: 'Não é possível excluir ambiente pois há endnodes associados',
      });
    }
  };

  const handleSearch = (text) => {
    setSearchText(text);
  };

  const handleEditClick = (environmentId) => {
    navigate(`/environment-form/${environmentId}`);
  };

  const handleMenuItemSelect = (environmentId, menuItem) => {
    switch (menuItem) {
      case 'Visualizar':
        getEnvironmentById(environmentId).then(() => setModalVisible(true));
        break;
      case 'Excluir':
        setModalConfirm({
          visible: true,
          message: 'Tem certeza que deseja excluir este ambiente?',
          operation: 'Excluir',
          id: environmentId,
        });
        break;
      default:
        break;
    }
  };

  const nextPage = async () => {
    setPage(page + 1);
  };

  const previousPage = async () => {
    setPage(page - 1);
  };

  return (
    <CorpoPagina loading={isLoading}>
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}

      {modalConfirm.visible && (
        <ModalConfirmacao
          aviso={modalConfirm.message}
          confirmar={false}
          clicado={() => {
            deleteEnvironment(modalConfirm.id);
            setModalConfirm({ visible: false, message: '', operation: '', id: '' });
          }}
          clicadoVolta={() =>
            setModalConfirm({ visible: false, message: '', operation: '', id: '' })
          }
        />
      )}

      {modalVisible && (
        <ModalView height={'100%'} width={'100%'}>
          <ModalTópico titulo="Visualizar Ambiente" />
          <div className="form-row">
            <div className="form-column">
              <FixedInput titulo="Nome" padrao={environment.name} tipo="text" disabled={true} />
              <FixedInput
                titulo="Referência"
                padrao={environment.reference}
                tipo="text"
                disabled={true}
              />
              {isMobile ? null : (
                <FixedInput
                  titulo="Offset de Temperatura"
                  padrao={environment.maxTemperatureOffset - environment.minTemperatureOffset}
                  tipo="text"
                  disabled={true}
                />
              )}
              {isMobile ? null : (
                <FixedInput
                  titulo="Offset de Umidade"
                  padrao={environment.maxHumidityOffset - environment.minHumidityOffset}
                  tipo="text"
                  disabled={true}
                />
              )}
            </div>
            <div className="form-column">
              <FixedInput
                titulo="Temperatura Mínima"
                padrao={environment.minTemperature}
                tipo="text"
                disabled={true}
              />
              <FixedInput
                titulo="Temperatura Máxima"
                padrao={environment.maxTemperature}
                tipo="text"
                disabled={true}
              />
              <FixedInput
                titulo="Umidade Mínima"
                padrao={environment.minHumidity}
                tipo="text"
                disabled={true}
              />
              <FixedInput
                titulo="Umidade Máxima"
                padrao={environment.maxHumidity}
                tipo="text"
                disabled={true}
              />
            </div>
          </div>
          <button
            style={isMobile ? { margin: 20 } : { margin: 90 }}
            id="BotaoCadastro"
            onClick={() => setModalVisible(false)}
          >
            Fechar
          </button>
        </ModalView>
      )}

      <div className="ContainerGeral">
        <TopicoTexto titulo="Lista de Ambientes" />
        {auth.perfilSalvo === 'OWNER' && (
          <BotaoCadastro
            visivel={auth.perfilSalvo === 'OWNER'}
            nome="Cadastrar"
            clicado={() => navigate('/AmbienteCadastro')}
          />
        )}
        <PesquisaInput placeholder="Insira o nome do ambiente" onSearch={handleSearch} />
        <TabelaComponente
          colunas={
            isMobile
              ? ['NOME', 'TOTAL DE ENDNODES']
              : ['NOME', 'SENSORES', 'ATUADORES', 'DESUMIDIFICADORES', 'TOTAL DE ENDNODES']
          }
          campos={
            isMobile
              ? ['name', 'endnodes']
              : ['name', 'sensors', 'actuators', 'dehumidifiers', 'endnodes']
          }
          linhas={environments}
          paginaAtual={page}
          total={totalEnvironments}
          aviso={!environments.length ? 'Não há ambientes cadastrados' : 'Buscando ambientes...'}
          menuOptions={menuOptions}
          onEditClick={handleEditClick}
          onMenuItemSelect={handleMenuItemSelect}
          goToNextPage={() => nextPage()}
          goToPreviousPage={() => previousPage()}
          entity={'environment'}
          role={auth.perfilSalvo}
        />
      </div>
    </CorpoPagina>
  );
}
